// extracted by mini-css-extract-plugin
export default {"ttl":"styles_ttl__9zTUG","closeBtn":"styles_closeBtn__QXjuo","submitBtn":"styles_submitBtn__GXfmA"};